<template>
  <div class="popup-edit">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px" size="small">
      <div class="white-container">
        <el-form-item label="弹窗分类" prop="popUpType" style="width: 424px">
          <el-select v-model="form.popUpType" placeholder="请选择弹窗分类" :disabled="disabledStatus">
            <el-option v-for="item in popUpType" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="弹窗名称" prop="popUpName" style="width: 424px">
          <el-input v-model="form.popUpName" placeholder="请输入弹窗名称" :disabled="disabledStatus" />
        </el-form-item>
        <el-form-item label="弹窗开始日期" prop="beginTime" style="width:295px;">
          <el-date-picker v-model="form.beginTime" type="date" placeholder="选择开始日期" class="custom-date" value-format="yyyy-MM-dd" @change="handleCheckDate" />
        </el-form-item>
        <el-form-item label="弹窗结束日期" prop="endTime" style="width:295px;">
          <el-date-picker v-model="form.endTime" type="date" placeholder="选择结束日期" class="custom-date" value-format="yyyy-MM-dd" @change="handleCheckDate" />
        </el-form-item>
        <div class="btn-wrap">
          <el-form-item label="按钮1" prop="btn1.type">
            <el-select v-model="form.btn1.type" placeholder="请选择按钮类型" :disabled="disabledStatus" class="type-select" @change="handleChangeBtn($event,1)">
              <el-option v-for="item in btnType" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
          <template v-if="form.btn1.type===0">
            <el-form-item label="按钮名称" label-width="100px" prop="btn1.name">
              <el-input v-model="form.btn1.name" placeholder="最多可输入4个汉字" maxlength="4" :disabled="disabledStatus" style="width: 147px;" />
            </el-form-item>
            <el-form-item label="按钮连接" label-width="100px" prop="btn1.url">
              <el-input v-model="form.btn1.url" placeholder="请输入按钮1链接" :disabled="disabledStatus" style="width: 270px;" />
            </el-form-item>
          </template>
        </div>
        <div class="btn-wrap">
          <el-form-item label="按钮2" prop="btn2.type">
            <el-select v-model="form.btn2.type" placeholder="请选择按钮类型" :disabled="disabledStatus" class="type-select" @change="handleChangeBtn($event,2)">
              <el-option v-for="item in btnType" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
          <template v-if="form.btn2.type===0">
            <el-form-item label="按钮名称" label-width="100px" prop="btn2.name">
              <el-input v-model="form.btn2.name" placeholder="最多可输入4个汉字" maxlength="4" :disabled="disabledStatus" style="width: 147px;" />
            </el-form-item>
            <el-form-item label="按钮连接" label-width="100px" prop="btn2.url">
              <el-input v-model="form.btn2.url" placeholder="请输入按钮2链接" :disabled="disabledStatus" style="width: 270px;" />
            </el-form-item>
          </template>
        </div>
        <el-form-item label="上传弹窗图片" prop="popUpImg" class="image-config">
          <div class="flex uploadImg-cont">
            <UploadImage :disabled="disabledStatus" :url="form.popUpImg" save-path="popup/" size-tips="969px*1140px" @triggerReg="handleCheckReg" @upload="data => (form.popUpImg = data)" />
          </div>
        </el-form-item>
        <el-form-item style="width: 100%; margin-top: 80px; margin-left: -50px">
          <div class="flex btns">
            <el-button type="info" @click="handleCancel">取消</el-button>
            <el-button type="primary" @click="submit">保存</el-button>
          </div>
        </el-form-item>
      </div>
    </el-form>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="dialogSuccess" />
  </div>
</template>
<script>
// import { mapActions, mapState } from 'vuex'
import { Popup } from "@/model/MpPopup";
import UploadImage from "@/components/UploadImage";
import Dialog from "@/components/Dialog";
const btnType = [{ id: 0, name: 'CTA' }, { id: 1, name: '返回' }];
const popUpType = [
  { id: 0, name: "CRM" },
  { id: 1, name: "Campaign" },
  { id: 2, name: "What’ s New" },
];
export default {
  components: { UploadImage, Dialog },

  data() {
    return {
      btnType,
      popUpType,
      formDialogShow: false,
      information: {},
      cancelTxt: "",
      form: new Popup(),
      disabledStatus: false,
      rules: {
        popUpType: [
          { required: true, message: "请选择弹窗类型", trigger: ["blur", "change"] },
        ],
        popUpName: [
          { required: true, message: "请输入弹窗名称", trigger: ["blur"] },
        ],
        beginTime: [
          {
            required: true, validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请选择开始日期"));
              } else if (this.form.endTime && this.$moment(value).valueOf() > this.$moment(this.form.endTime).valueOf()) {
                callback(new Error("开始日期不能晚于结束日期"));
              } else {
                callback();
              }
            }, trigger: ["change"],
          },
        ],
        endTime: [
          {
            required: false, validator: (rule, value, callback) => {
              if (value && this.form.beginTime && this.$moment(value).valueOf() < this.$moment(this.form.beginTime).valueOf()) {
                callback(new Error("结束日期不能早于开始日期"));
              } else {
                callback();
              }
            }, trigger: ["change"],
          },
        ],
        "btn1.type": [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (![0, 1].includes(value)) {
                callback(new Error("请选择按钮类型"));
              } else if (value && this.form.btn2.type) {
                callback(new Error("最多只能添加一个返回按钮"));
              } else {
                callback();
              }
            }, trigger: ["blur", "change"],
          },
        ],
        "btn1.name": [
          { required: true, message: "请输入按钮1名称", trigger: ["blur"] },
        ],
        "btn1.url": [
          { required: true, message: "请输入按钮1链接", trigger: ["blur"] },
        ],
        "btn2.type": [
          {
            required: false,
            validator: (rule, value, callback) => {
              if (value && this.form.btn1.type) {
                callback(new Error("最多只能添加一个返回按钮"));
              } else {
                callback();
              }
            }, trigger: ["blur", "change"],
          },
        ],
        "btn2.name": [
          { required: true, message: "请输入按钮2名称", trigger: ["blur"] },
        ],
        "btn2.url": [
          { required: true, message: "请输入按钮2链接", trigger: ["blur"] },
        ],
        popUpImg: [
          { required: true, message: "请上传图片", trigger: ["blur", "change"] },
        ],
      },
    };
  },
  async created() {
    const { query } = this.$route;
    if (query.id) {
      this.form.id = query.id;
      this.cancelTxt = "编辑";
      await this.getDetails("edit");
    } else if (query.copyid) {
      this.form.id = query.copyid;
      this.cancelTxt = "复制";
      await this.getDetails("copy");
    } else {
      this.cancelTxt = "新增";
    }
  },
  methods: {
    // 校验开始结束日期
    handleCheckDate() {
      this.$refs.form.validateField(["beginTime", "endTime"]);
    },
    // 改变按钮数据
    handleChangeBtn(value, n) {
      this.$refs.form.validateField(["btn1.type", "btn2.type"]);
      if (value === 1) {
        this.form[`btn${n}`] = {
          type: value,
          name: "返回",
          url: "",
        };
      } else if (value === 0) {
        this.form[`btn${n}`] = {
          type: value,
          name: "",
          url: "",
        };
      }
    },
    handleCheckReg(val) {
      this.$refs.form.validateField("popUpImg");
    },
    // 获弹窗详情
    async getDetails(type) {
      await this.$Api.popup.getDetail(this.form.id).then(res => {
        this.form = new Popup(res);
        if (type === "copy") delete this.form.id;
      });
    },
    submit() {
      this.formDialogShow = true;
      this.information = {
        operation: "submit",
        icon: "warn",
        subTitle: "请注意弹窗状态，保存后已发布的弹窗信息将实时更新至UA HOUSE小程序",
      };
    },
    // 处理数据
    dealForm() {
      const data = { ...this.form };
      data['buttonTypeConfig'] = [];
      if (data.btn1.type !== null) {
        data['buttonTypeConfig'].push(data.btn1);
      }
      if (data.btn2.type !== null) {
        data['buttonTypeConfig'].push(data.btn2);
      }
      delete data.btn1;
      delete data.btn2;
      return data;
    },
    addPopup() {
      const data = this.dealForm();
      this.$Api.popup.add(data).then(() => {
        this.$message.success("保存成功");
        setTimeout(() => {
          this.$router.push('/AIOminiApp-config/AIpopup');
        }, 2000);
      });
    },
    // 更新接口
    updatePopup() {
      const data = this.dealForm();
      this.$Api.popup.edit(data).then(() => {
        this.$message.success("编辑成功");
        setTimeout(() => {
          this.$router.push('/AIOminiApp-config/AIpopup');
        }, 2000);
      });
    },

    // 取消
    handleCancel() {
      this.formDialogShow = true;
      this.information = {
        operation: "cancel",
        icon: "warn",
        subTitle: `是否放弃${this.cancelTxt}，返回上级页面？`,
      };
    },
    dialogSuccess() {
      if (this.information.operation && this.information.operation === 'cancel') {
        this.$router.go(-1);
      } else if (this.information.operation && this.information.operation === 'submit') {
        this.$refs.form.validate(valid => {
          if (valid) {
            if (this.form.id) {
              this.updatePopup();
            } else {
              this.addPopup();
            }
          } else {
            return false;
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.popup-edit {
  .btns {
    align-items: center;
    justify-content: center;
    .el-button {
      width: 120px;
      height: 50px;
    }
    .el-button.el-button {
      margin-right: 30px;
    }
  }
  /deep/ .btn-wrap {
    display: flex;
    width: 100%;
    height: 32px;
    margin-bottom: 30px;
    .type-select {
      width: 147px !important;
      .el-input {
        width: 147px !important;
      }
    }
  }
  .el-form-item--small.el-form-item {
    margin-bottom: 30px;
  }
  .image-config {
    display: flex;

    .el-form-item__label {
      float: none;
    }

    /deep/.el-form-item__content {
      margin-left: 0 !important;
      .uploadImg-cont {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        .uploader {
          margin-bottom: 30px;
          &:last-child {
            margin-right: 0;
          }
          .uploader-image {
            .el-upload.el-upload--text {
              margin-bottom: 10px;
            }
          }
        }
      }
    }
    &.hide-required {
      .el-form-item__label {
        &::before {
          display: none;
        }
      }
    }
  }
}
</style>
